<div class="flex-1">
    <input type="date" class="p-inputtext p-component w-full" i18n-placeholder="@@date-time-picker.component.date" placeholder="Date" [(ngModel)]="date" [ngStyle]="{'border-top-right-radius':0,'border-bottom-right-radius':0,'height':'35px'}" >
</div>
<div class="ml-1">
    <input type="time" class="p-inputtext p-component" i18n-placeholder="@@date-time-picker.component.time" placeholder="Time" [(ngModel)]="time" step="300"  [ngStyle]="{'border-top-left-radius':0,'border-bottom-left-radius':0,'height':'35px'}" >
</div>

